import React, { useState, useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useAppContext } from '../../AppContext';

const CookieConsent = ({show, onAccept}) => {
 
  const {isMobile} = useAppContext(); 


  if (!show) return null;

  return (
    <Card
      style={{
        position: 'fixed',
        bottom: isMobile ? '90px':'20px',
        left: '20px',
        width: isMobile ? '50%' : '250px',
        zIndex: 1050,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        borderRadius: '12px',
      }}
      className="p-3"
    >
      <Card.Text style={{ fontSize: '11px', fontWeight: '500' }} className="mb-2">
      We use cookies to personalize your experience and keep things running smoothly. They’re safe and never collect sensitive info. By using this site, you agree to our use of cookies.
      <br
      />See our {' '}
        <a href="/privacy-policy#cookie-policy" target="_blank" rel="noopener noreferrer" style={{color:'#469B12'}}>
  Cookies Policy
</a>{' '}
        and{' '}
        <a href="/privacy-policy#privacy-policy" target="_blank" rel="noopener noreferrer"  style={{color:'#469B12'}}>
  Privacy Policy
</a>.
      </Card.Text>
      <div className='d-flex justify-content-end'>
      <Button
        className="px-3"
        onClick={onAccept}
        style={{ borderRadius: '8px', fontSize:'11px' }}
      >
        Got it!
      </Button>
      </div>
    </Card>
  );
};

export default CookieConsent;
